import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

/**
 * Code block with a copy-to-clipboard button.
 * Used throughout Zichtbaar Doc so colleagues can grab snippets in one click.
 */
const CodeBlock = ({ children, language = "", filename }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const [copied, setCopied] = useState(false);

  const code = typeof children === "string" ? children : String(children ?? "");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code.replace(/\n$/, ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable — ignore */
    }
  };

  return (
    <div
      className={`group relative my-3 overflow-hidden rounded-xl border ${
        isDark ? "border-white/[0.08] bg-[#0d0d0f]" : "border-gray-200 bg-[#0d1117]"
      }`}
    >
      {(filename || language) && (
        <div className="flex items-center justify-between border-b border-white/[0.06] px-4 py-2">
          <span className="font-mono text-[11px] text-gray-400">
            {filename || language}
          </span>
        </div>
      )}
      <button
        type="button"
        onClick={handleCopy}
        className="absolute right-2 top-2 z-10 flex items-center gap-1 rounded-md bg-white/[0.06] px-2 py-1 text-[11px] text-gray-300 opacity-0 transition hover:bg-white/[0.12] group-hover:opacity-100"
        aria-label="Kopieer code"
      >
        {copied ? <Check size={12} /> : <Copy size={12} />}
        {copied ? "Gekopieerd" : "Kopieer"}
      </button>
      <pre className="overflow-x-auto p-4 text-[12.5px] leading-relaxed">
        <code className="font-mono text-gray-200">{code}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
